(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('cart-drawer-section')) return;

    function formatMoney(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) return '';
      var lang = (document.documentElement && document.documentElement.lang) || 'es';
      try {
        return new Intl.NumberFormat(lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100) + '€';
      } catch (e) {
        return (cents / 100).toFixed(2) + '€';
      }
    }

    class CartDrawerSection extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.root = this.querySelector('[data-cart-drawer]');
        this.panel = this.querySelector('.cart-drawer__panel');
        this.lastFocus = null;
        this.onKeydown = this.onKeydown.bind(this);
        this.onCartChange = this.onCartChange.bind(this);
      }

      connectedCallback() {
        document.addEventListener('cart:change', this.onCartChange);
        document.addEventListener('cart-drawer:open', () => this.open());
        document.addEventListener('cart-drawer:close', () => this.close());
      }

      disconnectedCallback() {
        document.removeEventListener('cart:change', this.onCartChange);
      }

      isOpen() {
        return this.root && this.root.getAttribute('aria-hidden') === 'false';
      }

      open() {
        if (!this.root) return;
        this.lastFocus = document.activeElement;
        this.root.removeAttribute('hidden');
        requestAnimationFrame(() => {
          this.root.setAttribute('aria-hidden', 'false');
          document.body.classList.add('is-cart-drawer-open');
          var focusable = this.panel && this.panel.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          if (focusable) focusable.focus();
          else if (this.panel) this.panel.focus();
          document.addEventListener('keydown', this.onKeydown);
        });
      }

      close() {
        if (!this.root || this.root.getAttribute('aria-hidden') === 'true') return;
        this.root.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('is-cart-drawer-open');
        document.removeEventListener('keydown', this.onKeydown);
        var self = this;
        var onTransitionEnd = function (e) {
          if (e.target !== self.panel) return;
          self.root.setAttribute('hidden', '');
          self.panel.removeEventListener('transitionend', onTransitionEnd);
          if (self.lastFocus && typeof self.lastFocus.focus === 'function') self.lastFocus.focus();
        };
        if (this.panel) this.panel.addEventListener('transitionend', onTransitionEnd);
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.key !== 'Tab' || !this.panel) return;
        var focusables = this.panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (focusables.length === 0) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      onCartChange(event) {
        var self = this;
        var cart = event && event.detail && event.detail.cart;
        if (!cart || !this.root) return;

        var currentLines = this.root.querySelectorAll('[data-cart-line]');
        var currentCount = currentLines.length;
        var serverItems = cart.items || [];
        var serverCount = serverItems.length;
        var isEmpty = serverCount === 0;

        if (currentCount === 0 && isEmpty) return;

        var keysChanged = false;
        for (var k = 0; k < currentCount; k++) {
          var serverItem = serverItems[k];
          if (!serverItem || currentLines[k].getAttribute('data-line-key') !== serverItem.key) {
            keysChanged = true;
            break;
          }
        }

        if (currentCount !== serverCount || keysChanged) {
          clearTimeout(this._refreshTimer);
          this._refreshTimer = setTimeout(function () { self.refresh(); }, 50);
          return;
        }

        this.applyInPlace(cart);
      }

      applyInPlace(cart) {
        if (!this.root) return;
        var items = cart.items || [];

        var totalNode = this.root.querySelector('[data-cart-total]');
        if (totalNode && typeof cart.total_price === 'number') {
          totalNode.textContent = formatMoney(cart.total_price);
        }

        var countNode = this.root.querySelector('[data-cart-count]');
        if (countNode && typeof cart.item_count === 'number') {
          var current = countNode.textContent || '';
          var updated = current.replace(/^\d+/, String(cart.item_count));
          if (updated !== current) countNode.textContent = updated;
        }

        var escapeAttr = (window.CSS && typeof window.CSS.escape === 'function')
          ? window.CSS.escape
          : function (v) { return String(v).replace(/(["\\])/g, '\\$1'); };

        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          var lineEl = this.root.querySelector('[data-line-key="' + escapeAttr(item.key) + '"]');
          if (!lineEl) continue;
          var price = (item.line_price != null)
            ? item.line_price
            : (item.final_line_price != null ? item.final_line_price : (item.original_line_price || 0));
          var priceNode = lineEl.querySelector('[data-line-price]');
          if (priceNode && !lineEl.classList.contains('cart-line--sample')) priceNode.textContent = formatMoney(price);
          lineEl.setAttribute('data-line-quantity', String(item.quantity));
          var qtyInput = lineEl.querySelector('[data-quantity-input]');
          if (qtyInput) qtyInput.value = String(item.quantity);
        }
      }

      refresh() {
        var self = this;
        var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + '?sections=' + encodeURIComponent(self.sectionId);
        return fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var html = data[self.sectionId];
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var freshRoot = doc.querySelector('[data-cart-drawer]');
            if (!freshRoot || !self.root) return;
            var oldOpen = self.isOpen() || !self.root.hasAttribute('hidden');
            var ownerDoc = self.root.ownerDocument;
            var imported = Array.from(freshRoot.children, function (node) {
              return ownerDoc.importNode(node, true);
            });
            self.root.replaceChildren.apply(self.root, imported);
            if (oldOpen) {
              self.root.setAttribute('aria-hidden', 'false');
              self.root.removeAttribute('hidden');
            } else {
              self.root.setAttribute('aria-hidden', 'true');
              self.root.setAttribute('hidden', '');
            }
          })
          .catch(function (err) { console.error('[cart-drawer] refresh failed:', (err && err.message) || 'unknown error'); });
      }
    }

    customElements.define('cart-drawer-section', CartDrawerSection);

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-cart-drawer-toggle]');
      if (trigger) {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('cart-drawer:open'));
        return;
      }
      var closer = event.target.closest('[data-cart-drawer-close]');
      if (closer) {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('cart-drawer:close'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var rootEl = null;

    function getRoot() {
      if (!rootEl || !rootEl.isConnected) {
        rootEl = document.querySelector('[data-cart-root]');
      }
      return rootEl;
    }

    function formatMoney(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) return '';
      var lang = (document.documentElement && document.documentElement.lang) || 'es';
      try {
        return new Intl.NumberFormat(lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100) + '€';
      } catch (e) {
        return (cents / 100).toFixed(2) + '€';
      }
    }

    function applyTotalsInPlace(cart) {
      var root = getRoot();
      if (!root) return;

      var totalNode = root.querySelector('[data-cart-total]');
      if (totalNode && typeof cart.total_price === 'number') {
        totalNode.textContent = formatMoney(cart.total_price);
      }

      var countNode = root.querySelector('[data-cart-count]');
      if (countNode && typeof cart.item_count === 'number') {
        var current = countNode.textContent || '';
        var updated = current.replace(/^\d+/, String(cart.item_count));
        if (updated !== current) countNode.textContent = updated;
      }
    }

    document.addEventListener('cart:change', function (event) {
      var cart = event.detail && event.detail.cart;
      if (!cart) return;

      try {
        applyTotalsInPlace(cart);
      } catch (err) {
        console.error('[cart] in-place totals update failed:', (err && err.message) || 'unknown error');
      }

      if (cart.item_count === 0) {
        window.location.reload();
      }
    });

    document.addEventListener('cart:error', function (event) {
      var err = event.detail && event.detail.error;
      console.error('[cart] error:', err);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(function () {
  // Sort select preserves filter URL params
  var sortSelect = document.getElementById('catalog-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // Filter checkboxes navigate to Shopify-provided filter URLs
  document.querySelectorAll('.filter-option input[type="checkbox"]').forEach(function (cb) {
    cb.addEventListener('change', function () {
      var url = this.checked ? this.dataset.urlAdd : this.dataset.urlRemove;
      if (url) window.location.href = url;
    });
  });

  // Mobile filter sidebar toggle
  var toggleBtn = document.getElementById('mobile-filter-btn');
  var sidebar = document.getElementById('filters-sidebar');
  if (toggleBtn && sidebar) {
    toggleBtn.addEventListener('click', function () {
      var isOpen = sidebar.classList.toggle('is-open');
      toggleBtn.setAttribute('aria-expanded', isOpen);
    });
    // Close on outside click
    document.addEventListener('click', function (e) {
      if (sidebar.classList.contains('is-open') && !sidebar.contains(e.target) && !toggleBtn.contains(e.target)) {
        sidebar.classList.remove('is-open');
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__contactRequestBound) return;
  window.__contactRequestBound = true;

  function init() {
    var source = document.querySelector('[data-contact-request-source]');
    if (!source) return;

    var textarea = document.querySelector('textarea[name="contact[body]"]');
    if (!textarea) return;

    if (textarea.value && textarea.value.trim() !== '') return;

    var raw = source.textContent || source.innerHTML || '';
    var message = raw
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<[^>]+>/g, '')
      .replace(/\u00a0/g, ' ')
      .trim();

    textarea.value = message;
    textarea.dispatchEvent(new Event('input', { bubbles: true }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  const STORAGE_KEY = 'alkyra:search-hint-seen:v2';
  const SHOW_DELAY_MS = 3000;
  const AUTO_HIDE_MS = 12000;
  const wrapper = document.querySelector('[data-search-tooltip-wrapper]');
  if (!wrapper) return;
  const tooltip = wrapper.querySelector('[data-search-tooltip]');
  const trigger = wrapper.querySelector('[data-search-drawer-open]');
  const closeBtn = wrapper.querySelector('[data-search-tooltip-close]');
  const actionBtn = wrapper.querySelector('[data-search-tooltip-action]');
  if (!tooltip || !trigger) return;

  let dismissed = false;
  let showTimer = null;
  let hideTimer = null;

  const dismiss = () => {
    if (dismissed) return;
    dismissed = true;
    if (showTimer) { clearTimeout(showTimer); showTimer = null; }
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    tooltip.setAttribute('aria-hidden', 'true');
    trigger.removeAttribute('aria-describedby');
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (_) {}
  };

  const show = () => {
    if (dismissed) return;
    tooltip.setAttribute('aria-hidden', 'false');
    if (tooltip.id) trigger.setAttribute('aria-describedby', tooltip.id);
    hideTimer = setTimeout(dismiss, AUTO_HIDE_MS);
  };

  try {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
  } catch (_) {}

  showTimer = setTimeout(show, SHOW_DELAY_MS);

  trigger.addEventListener('click', dismiss, { once: true });
  const openSearch = () => trigger.click();
  if (actionBtn) {
    actionBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openSearch();
    });
  } else {
    tooltip.addEventListener('click', (e) => {
      if (e.target.closest('[data-search-tooltip-close]')) return;
      openSearch();
    });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      dismiss();
    });
  }
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') dismiss(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"] && !Shopify.designMode) return;
  try {
    
(function () {
  function showView(card, view) {
    card.dataset.view = view;
    card.querySelectorAll('.main-login__view').forEach(function (panel) {
      panel.classList.toggle('is-hidden', panel.dataset.view !== view);
    });
    card.querySelectorAll('.main-login__tab').forEach(function (tab) {
      var active = tab.dataset.switch === view || (view === 'recover' && tab.dataset.switch === 'login');
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
    });
  }

  document.querySelectorAll('[data-switch]').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      var card = trigger.closest('.main-login__card');
      if (!card) return;
      var view = trigger.dataset.switch;
      if (!view) return;

      var sameOriginSwap = trigger.tagName === 'A' && trigger.getAttribute('href');
      if (sameOriginSwap && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
        event.preventDefault();
        var url = new URL(trigger.href, window.location.origin);
        history.replaceState({}, '', url.pathname + url.search);
        showView(card, view);
      }
    });
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-pack"]) return;
  try {
    
  (function () {
    var form = document.getElementById('pk-product-form');
    if (!form) return;
    var button = form.querySelector('.pk-hero__add');
    var error = document.querySelector('[data-pk-error]');

    form.addEventListener('submit', function (event) {
      var idInput = form.querySelector('input[name="id"]');
      if (!window.AlkyraCart || !idInput || !idInput.value || (button && button.disabled)) return;
      event.preventDefault();
      if (error) error.hidden = true;
      if (button) {
        button.classList.add('is-loading');
        button.disabled = true;
      }
      window.AlkyraCart.add(parseInt(idInput.value, 10), 1)
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));
          return window.AlkyraCart.refresh('pack');
        })
        .catch(function (err) {
          if (!error) return;
          error.textContent = (err && err.payload && (err.payload.description || err.payload.message)) || (err && err.message) || '';
          error.hidden = false;
        })
        .finally(function () {
          if (button) {
            button.classList.remove('is-loading');
            button.disabled = false;
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-inci-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('[data-inci-collection]');
  if (!root) return;

  const input = root.querySelector('[data-inci-search]');
  const grid = root.querySelector('[data-inci-grid]');
  const noResults = root.querySelector('[data-inci-no-results]');
  if (!input || !grid) return;

  const labels = Array.from(grid.querySelectorAll('.label'));

  function autoSize() {
    labels.forEach((label) => {
      if (label.classList.contains('hidden')) return;
      let pts = 10.0;
      label.style.fontSize = pts + 'pt';
      while (label.scrollHeight > label.offsetHeight + 1 && pts > 1.5) {
        pts = Math.round((pts - 0.2) * 10) / 10;
        label.style.fontSize = pts + 'pt';
      }
    });
  }

  function filter() {
    const q = input.value.trim().toLowerCase();
    let any = false;
    labels.forEach((label) => {
      const header = label.querySelector('.label-header');
      const match = !q || (header && header.textContent.toLowerCase().indexOf(q) !== -1);
      label.classList.toggle('hidden', !match);
      if (match) any = true;
    });
    if (noResults) noResults.style.display = any ? 'none' : 'block';
    autoSize();
  }

  input.addEventListener('input', filter);
  document.addEventListener('DOMContentLoaded', autoSize);
  window.addEventListener('load', autoSize);
  window.addEventListener('beforeprint', autoSize);
  window.addEventListener('resize', () => {
    clearTimeout(window.__inciResize);
    window.__inciResize = setTimeout(autoSize, 120);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function () {
  /* ── VARIANT CHIPS ── */
  var variantIdInput = document.getElementById('variant-id');
  var priceEl = document.getElementById('pd-price');
  var unitAmountEl = document.getElementById('pd-unit-amount');
  var unitNoteEl = document.getElementById('pd-unit-note');
  var subtitleVariantEl = document.getElementById('pd-subtitle-variant');
  var metaFormatEl = document.getElementById('pd-meta-format');
  var submitBtn = document.querySelector('.pd-want-btn[type="submit"]');
  var qtyInput = document.getElementById('pd-qty');

  document.querySelectorAll('.pd-size-chip').forEach(function (chip) {
    chip.addEventListener('click', function () {
      if (this.getAttribute('aria-disabled') === 'true') return;
      document.querySelectorAll('.pd-size-chip').forEach(function (c) { c.classList.remove('active'); });
      this.classList.add('active');
      if (variantIdInput) variantIdInput.value = this.dataset.variantId;
      if (priceEl) priceEl.textContent = this.dataset.variantPriceFormatted;
      if (unitAmountEl) unitAmountEl.textContent = this.dataset.variantUnitPrice || '';
      if (unitNoteEl) {
        unitNoteEl.textContent = this.dataset.variantUnitNote || '';
        unitNoteEl.hidden = !this.dataset.variantUnitNote;
      }
      if (subtitleVariantEl) subtitleVariantEl.textContent = this.dataset.variantTitle;
      if (metaFormatEl) metaFormatEl.textContent = this.dataset.variantTitle;
    });
  });

  /* ── QUANTITY ── */
  /* The +/- buttons are driven by the global handler in assets/theme.js
     (initGlobalQuantity), which uses the data-quantity-* attributes and
     respects the input's min/max attributes. Nothing to do here. */

  /* ── WHATSAPP MODAL ── */
  var i18nRoot = document.querySelector('.pd-hero') || document.body;
  var waNumber = i18nRoot.getAttribute('data-wa-number') || '';
  var productName = i18nRoot.getAttribute('data-product-name') || '';
  var waBtn = document.getElementById('pd-wa-btn');
  var waModal = document.getElementById('wa-modal');
  var waLink = document.getElementById('wa-modal-link');
  var waMessage = document.getElementById('wa-modal-message');
  var waClose = document.getElementById('wa-modal-close');
  var waBackdrop = document.getElementById('wa-modal-backdrop');
  var waCopy = document.getElementById('wa-modal-copy');

  var waCopyDefaultLabel = waCopy ? (waCopy.getAttribute('data-wa-copy-label') || waCopy.textContent.trim()) : '';
  function waT(key) {
    return i18nRoot.getAttribute('data-i18n-' + key) || '';
  }

  function buildWaMessage() {
    var activeChip = document.querySelector('.pd-size-chip.active');
    var variant = activeChip ? activeChip.dataset.variantTitle : '';
    var price = priceEl ? priceEl.textContent : '';
    var qty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
    var greetingTpl = waT('wa-greeting') || '';
    var lines = [greetingTpl.replace('{name}', productName)];
    if (variant) lines.push(waT('wa-format') + variant);
    lines.push(waT('wa-price') + price);
    if (qty > 1) lines.push(waT('wa-quantity') + qty);
    lines.push(waT('wa-closing'));
    return lines.join('\n');
  }

  function openWaModal() {
    var msg = buildWaMessage();
    if (waMessage) waMessage.textContent = msg;
    if (waLink) waLink.href = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(msg);
    if (waModal) {
      waModal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      if (waClose) waClose.focus();
    }
  }

  function closeWaModal() {
    if (waModal) { waModal.setAttribute('hidden', ''); document.body.style.overflow = ''; }
  }

  if (waBtn) waBtn.addEventListener('click', openWaModal);
  if (waClose) waClose.addEventListener('click', closeWaModal);
  if (waBackdrop) waBackdrop.addEventListener('click', closeWaModal);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeWaModal(); });

  if (waCopy) {
    waCopy.addEventListener('click', function () {
      var text = waMessage ? waMessage.textContent : '';
      navigator.clipboard.writeText(text).then(function () {
        waCopy.textContent = waT('wa-copied') || '';
        waCopy.classList.add('copied');
        setTimeout(function () {
          waCopy.textContent = waCopyDefaultLabel;
          waCopy.classList.remove('copied');
        }, 2000);
      });
    });
  }

  /* ── AJAX ADD TO CART ── */
  var productForm = document.getElementById('pd-product-form');
  var formError = document.querySelector('[data-pd-form-error]');

  function showFormError(message) {
    if (!formError) return;
    formError.textContent = message;
    formError.removeAttribute('hidden');
  }

  function clearFormError() {
    if (!formError) return;
    formError.textContent = '';
    formError.setAttribute('hidden', '');
  }

  if (productForm) {
    productForm.addEventListener('submit', function (event) {
      if (!window.AlkyraCart || !variantIdInput || !variantIdInput.value) return;
      if (submitBtn && submitBtn.disabled) return;

      event.preventDefault();
      clearFormError();
      if (submitBtn) {
        submitBtn.classList.add('is-loading');
        submitBtn.disabled = true;
      }

      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var id = parseInt(variantIdInput.value, 10);

      window.AlkyraCart.add(id, qty)
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));
          return window.AlkyraCart.refresh('product');
        })
        .catch(function (err) {
          var msg = (err && err.payload && (err.payload.message || err.payload.description))
            || (err && err.message)
            || waT('cart-add-error')
            || '';
          showFormError(msg);
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.classList.remove('is-loading');
            submitBtn.disabled = false;
          }
        });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["refill-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (typeof window === 'undefined') return;
  var STORAGE_KEY = 'alkyra:refill-banner-dismissed:v1';
  var banner = document.querySelector('[data-refill-banner-close]');
  if (!banner) return;
  var wrap = banner.closest('.refill-banner');
  if (!wrap) return;

  try {
    if (sessionStorage.getItem(STORAGE_KEY) === '1') {
      wrap.classList.add('is-hidden');
      return;
    }
  } catch (e) {}

  banner.addEventListener('click', function () {
    wrap.classList.add('is-hidden');
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  });
})();

  } catch(e) { console.error(e); }
})();
})();
